<insurance-packages-icd10-diagnoses-browser
  class="min-h-0"
  [codes]="codes()"
  [search]="search()"
  [searchState]="searchState()"
  [names]="dictionary.names()"
  [nodes]="dictionary.nodes()"
  [blockCodes]="dictionary.blockCodes()"
  [blocksState]="dictionary.blocksState()"
  [fillHeight]="fillHeight()"
  (blockOpened)="dictionary.loadBlockNames($event)"
  (categoryOpened)="dictionary.loadCategoryNames($event)"
  (retryGroups)="dictionary.loadBlocks()"
  (retrySearch)="dictionary.search($event)"
></insurance-packages-icd10-diagnoses-browser>
